export class Owner{
    document: string;
    firstName: string;
    lastName: string;
    username: string;
    phone: string;
    documentType:string;
}